
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ExecutionResult, IDocument, IDocumentCriteria, ReportDeliveryViewModel, ShareReportParams } from "@tylertech/tyler-api-types";

/**
 * ReportDeliveryService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class ReportDeliveryService {
    private readonly $apiService = inject(ApiService);
    
    Archive(pDelivery: ReportDeliveryViewModel): Promise<ExecutionResult<boolean>> {
        return this.$apiService.sendAuth("IReportDeliveryService/Archive", pDelivery);
    }
    Delete(pDelivery: ReportDeliveryViewModel): Promise<ExecutionResult<boolean>> {
        return this.$apiService.sendAuth("IReportDeliveryService/Delete", pDelivery);
    }
    GenerateAndView(criteria: IDocumentCriteria): Promise<IDocument> {
        return this.$apiService.sendAuth("IReportDeliveryService/GenerateAndView", criteria);
    }
    GetUserList(): Promise<ExecutionResult<any>> {
        return this.$apiService.sendAuth("IReportDeliveryService/GetUserList");
    }
    Share(pInfo: ShareReportParams): Promise<ExecutionResult<boolean>> {
        return this.$apiService.sendAuth("IReportDeliveryService/Share", pInfo);
    }
    View(pDelivery: ReportDeliveryViewModel): Promise<ExecutionResult<IDocument>> {
        return this.$apiService.sendAuth("IReportDeliveryService/View", pDelivery);
    }
}
